import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest
} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {AppService} from '@services/app.service';
import {environment} from 'environments/environment';
import {catchError, EMPTY, Observable, switchMap, throwError} from 'rxjs';
import {GenrateToken} from './common/Models/generateToken.model';
import {ToastrService} from 'ngx-toastr';
import {Router} from '@angular/router';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
    private baseUrl = environment.apiUrl;
    private subdomain: string;
    currentUser: GenrateToken;

    constructor(
        private authService: AppService,
        private router: Router,
        private toastr: ToastrService
    ) {
        this.subdomain = this.getSubdomain();
    }

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        const email = this.authService.currentEmail;
        const password = this.authService.currentPassword;

        const authUser = localStorage.getItem('authUser');
        const token = authUser ? JSON.parse(authUser).token : null;

        let authReq = req.clone({
            setHeaders: {
                'X-Subdomain': this.subdomain,
                ...(token ? {Authorization: `Bearer ${token}`} : {})
            }
        });

        if (token) {
            const tokenExpiration = this.getTokenExpiration(token);
            const now = new Date();

            if (tokenExpiration && tokenExpiration < now) {
                localStorage.removeItem('authUser');

                if (email && password) {
                    return this.authService.login(email, password).pipe(
                        switchMap((data: any) => {
                            localStorage.setItem(
                                'authUser',
                                JSON.stringify(data)
                            );
                            const newToken = data.token;

                            const updatedReq = req.clone({
                                setHeaders: {
                                    Authorization: `Bearer ${newToken}`,
                                    'X-Subdomain': this.subdomain
                                }
                            });

                            return next.handle(updatedReq);
                        }),
                        catchError((error) => {
                            if (error.status === 401) {
                                this.toastr.error(
                                    'Session expired. Please log in again.'
                                );
                                this.router.navigate(['/login']);
                            }
                            if (error.status === 409) {
                                this.toastr.warning(
                                    error.error ||
                                        'error processing request/response'
                                );
                            }
                            return throwError(() => error);
                        })
                    );
                } else {
                    return next.handle(authReq);
                }
            }
        }

        return next.handle(authReq).pipe(
            catchError((error) => {
                if (error.status === 401) {
                    this.toastr.error('Session expired. Please log in again.');
                    this.router.navigate(['/login']);
                    return EMPTY;
                }
                if (error.status === 409) {
                    this.toastr.warning(
                        error.error || 'error processing request/response'
                    );
                    return EMPTY;
                }
                return throwError(() => error);
            })
        );
    }

    private getTokenExpiration(token: string): Date | null {
        const tokenPayload = JSON.parse(atob(token.split('.')[1]));
        if (tokenPayload.exp) {
            return new Date(tokenPayload.exp * 1000); // Convert to milliseconds
        }
        return null;
    }

    private getSubdomain(): string {
        const host = window.location.hostname;
        return host;
    }
}
